<div class="duna-user-settings">
  <h2 class="heading">Online kalender</h2>
  @if (userName) {
  <p class="user-name">{{ userName }}</p>
  }

  <div class="explanation">
    <p>
      <strong>Hvad er det?</strong> Din online kalender er et personligt link,
      der viser alle de events, du er tilmeldt. Kalenderen opdateres automatisk,
      når du tilmelder eller afmelder dig events.
    </p>
    <p>
      Du kan tilføje linket som et abonnement i Outlook, Google Kalender eller
      andre kalenderapps – så får du alle dine tilmeldte begivenheder samlet i
      din egen kalender uden at skulle downloade filer.
    </p>
  </div>

  @if (calendarUrl) {
  <div class="url-section">
    <label class="url-label" for="calendar-url">Dit kalenderlink</label>
    <div class="url-row">
      <input
        id="calendar-url"
        type="text"
        class="url-input"
        [value]="calendarUrl"
        readonly
        aria-label="Kalender-URL"
      />
      <button mat-flat-button color="primary" (click)="copyLink()">
        Kopier link
      </button>
    </div>
    <p class="privacy">
      Del ikke linket med andre; det giver adgang til dine tilmeldte events.
    </p>
  </div>
  } @if (!calendarUrl) {
  <div class="loading-hint">
    <p>Henter dit kalenderlink...</p>
  </div>
  }

  <app-duna-user-notification-preferences></app-duna-user-notification-preferences>

  <app-duna-user-catering-preferences></app-duna-user-catering-preferences>

  <p class="device-debug-footer">
    <button type="button" class="device-debug-link" (click)="openDeviceDebug()">
      Enhedsinfo (fejlsøgning)
    </button>
  </p>
</div>
